import { MesfModal } from "@dexteel/mesf-core";
import { Button, Grid, Typography } from "@mui/material";
import { ChargeLayer } from "@/pages/sy/models/ChargeLayer";

export const ChangeStatusScheduledModal = ({
  showStatusChangeConfirmation,
  handleConfirmStatusChange,
  handleCancelStatusChange,
  chargeLayers,
}: {
  showStatusChangeConfirmation: boolean;
  handleConfirmStatusChange: () => void;
  handleCancelStatusChange: () => void;
  chargeLayers: ChargeLayer[];
}) => {
  return (
    <MesfModal
      title="WARNING: Change Status to Scheduled"
      open={showStatusChangeConfirmation}
      handleClose={handleCancelStatusChange}
      maxWidth="md"
    >
      <MesfModal.Content style={{ padding: "15px 30px" }}>
        <Typography variant="body1" style={{ marginBottom: "15px" }}>
          Changing the charge status to <strong>Scheduled</strong> will delete
          all associated charge layers ({chargeLayers.length} layer(s) found).
        </Typography>
        <Typography variant="body1">
          Are you sure you want to continue?
        </Typography>
      </MesfModal.Content>
      <MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item md={3} xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="inherit"
              onClick={handleCancelStatusChange}
            >
              Cancel
            </Button>
          </Grid>
          <Grid item md={3} xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleConfirmStatusChange}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      </MesfModal.Actions>
    </MesfModal>
  );
};
